
import BenchmarksDetailContainer from 'containers/BenchmarksDetailContainer';

export default (props: any) => <BenchmarksDetailContainer {...props} />;
